import { handleBackdropClick } from "./handleBackdropClick";
import { handleKeyDown } from "./handleKeyDown";

export const manageEventListeners = (modal, add) => {
  const eventListenersMap = new Map();
  const backdropClickListener = (event) => handleBackdropClick(event, modal);
  const keyDownListener = (event) => handleKeyDown(event, modal);

  if (add) {
    modal.addEventListener("click", backdropClickListener, false);
    window.addEventListener("keydown", keyDownListener, false);
    eventListenersMap.set(modal, { backdropClickListener, keyDownListener });
  } else {
    const listeners = eventListenersMap.get(modal);
    if (listeners) {
      modal.removeEventListener("click", listeners.backdropClickListener);
      window.removeEventListener("keydown", listeners.keyDownListener);
      eventListenersMap.delete(modal);
    }
  }
};
